"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShortcuts = exports.ShortcutsProvider = void 0;
var react_1 = __importStar(require("react"));
var shortcuts_json_1 = __importDefault(require("./shortcuts.json"));
var SHORTCUTS = shortcuts_json_1.default.map(function (_a) {
    var shortcuts = _a.shortcuts;
    return shortcuts;
}).flat();
var ShortcutsContext = (0, react_1.createContext)({});
var REPEAT_THROTTLE_MS = 130;
var isInputFocused = function () {
    var inputElements = ['INPUT', 'TEXTAREA', 'SELECT'];
    var activeElement = document.activeElement;
    return activeElement instanceof HTMLElement &&
        (inputElements.includes(activeElement.tagName) || activeElement.isContentEditable);
};
var ShortcutsProvider = function (_a) {
    var children = _a.children, onShortcut = _a.onShortcut;
    var listeners = (0, react_1.useRef)(new Map());
    var lastRepeatTime = (0, react_1.useRef)(new Map());
    var onKeyDown = (0, react_1.useCallback)(function (_a) {
        var _b;
        var ctrlKey = _a.ctrlKey, shiftKey = _a.shiftKey, altKey = _a.altKey, metaKey = _a.metaKey, code = _a.code, key = _a.key, repeat = _a.repeat;
        if (isInputFocused())
            return;
        if (repeat) {
            var now = Date.now();
            var last = (_b = lastRepeatTime.current.get(code)) !== null && _b !== void 0 ? _b : 0;
            if (now - last < REPEAT_THROTTLE_MS)
                return;
            lastRepeatTime.current.set(code, now);
        }
        SHORTCUTS.forEach(function (_a) {
            var name = _a.name, combos = _a.combos;
            return combos.forEach(function (keys) {
                var _a;
                var modifers = (keys.includes('Ctrl') === ctrlKey)
                    && (keys.includes('Shift') === shiftKey)
                    && !altKey
                    && !metaKey;
                if (modifers && (keys.includes(code) || keys.includes(key.toUpperCase()))) {
                    var combo_1 = combos.indexOf(keys);
                    (_a = listeners.current.get(name)) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) { return listener(combo_1, key); });
                    onShortcut(name, combo_1, key);
                }
            });
        });
    }, [onShortcut]);
    var on = function (name, listener) {
        !listeners.current.has(name) && listeners.current.set(name, new Set());
        listeners.current.get(name).add(listener);
    };
    var off = function (name, listener) {
        var _a;
        (_a = listeners.current.get(name)) === null || _a === void 0 ? void 0 : _a.delete(listener);
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('keydown', onKeyDown);
        return function () { return document.removeEventListener('keydown', onKeyDown); };
    }, [onKeyDown]);
    return (react_1.default.createElement(ShortcutsContext.Provider, { value: { grouped: shortcuts_json_1.default, on: on, off: off } }, children));
};
exports.ShortcutsProvider = ShortcutsProvider;
var useShortcuts = function () {
    return (0, react_1.useContext)(ShortcutsContext);
};
exports.useShortcuts = useShortcuts;
